import { useGetForumCompanyPackageQuery } from "api/queries/forumCompanies";
import { Spin } from "components/styleguide";
import { CompanyPackageModel } from "generated/api";
import { EventLayoutContext } from "layouts/EventLayout/types";
import { FC } from "react";
import { useOutletContext } from "react-router-dom";

import ForumCompanyPackage from "./ForumCompanyPackage";
import ForumCompanyPackageForm from "./ForumCompanyPackageForm";

interface ForumCompanyPackagePanelProps {
  forumId: number;
  forumCompanyId: number;
  companyName: string;
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
}

const ForumCompanyPackagePanel: FC<ForumCompanyPackagePanelProps> = ({
  forumId,
  forumCompanyId,
  companyName,
  isEditing,
  setIsEditing,
}) => {
  const { isLoading, data: { data: companyPackage = {} as CompanyPackageModel } = {} } = useGetForumCompanyPackageQuery(
    {
      forumId,
      forumCompanyId,
    },
  );

  const { forum } = useOutletContext<EventLayoutContext>();

  if (isLoading || !companyPackage) {
    return (
      <div className="loader">
        <Spin />
      </div>
    );
  }

  return isEditing ? (
    <ForumCompanyPackageForm
      forumId={forumId}
      forumCompanyId={forumCompanyId}
      companyName={companyName}
      initialValues={companyPackage}
      setIsEditing={setIsEditing}
      forumStartDate={forum?.startDate}
      forumEndDate={forum?.endDate}
    />
  ) : (
    <ForumCompanyPackage companyPackage={companyPackage} companyName={companyName} />
  );
};

export default ForumCompanyPackagePanel;
